// src/components/admin/AppSelectorDrawer.jsx
import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const AppSelectorDrawer = ({ isOpen, onClose, apps, selectedAppIds, onSave }) => {
  const [search, setSearch] = useState('');
  const [localSelected, setLocalSelected] = useState([]);

  useEffect(() => {
    setLocalSelected(selectedAppIds || []);
  }, [selectedAppIds]);

  const isAllSelected = localSelected.includes('all');

  const handleToggle = (appId) => {
    if (isAllSelected) return; // don't allow toggling when all is selected
    setLocalSelected(prev =>
      prev.includes(appId) ? prev.filter(id => id !== appId) : [...prev, appId]
    );
  };

  const handleSelectAll = () => {
    setLocalSelected(['all']);
  };

  const handleClearAll = () => {
    setLocalSelected([]);
  };

  const filteredApps = apps.filter(app =>
    app.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div
      className={`fixed top-0 right-0 w-96 h-full bg-white shadow-lg transform transition-transform duration-300 z-50 ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      <div className="flex justify-between items-center border-b p-4">
        <h3 className="text-lg font-semibold">Select Apps</h3>
        <button onClick={onClose}><X /></button>
      </div>

      <div className="p-4 space-y-4">
        <div className="flex gap-2">
          <button onClick={handleSelectAll} className="bg-blue-100 text-blue-700 text-sm px-3 py-1 rounded">
            Select All Apps
          </button>
          <button onClick={handleClearAll} className="text-sm text-gray-600 underline">
            Clear
          </button>
        </div>

        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search apps..."
          className="border px-3 py-2 rounded w-full"
          disabled={isAllSelected}
        />

        <div className="space-y-2 max-h-[60vh] overflow-y-auto">
          {filteredApps.map(app => (
            <label
              key={app._id}
              className="flex items-center gap-2 border px-3 py-2 rounded cursor-pointer"
            >
              <input
                type="checkbox"
                checked={isAllSelected || localSelected.includes(app._id)}
                onChange={() => handleToggle(app._id)}
                disabled={isAllSelected}
              />
              {app.name}
            </label>
          ))}
        </div>

        <div className="pt-4 border-t flex gap-2 justify-end">
          <button
            onClick={() => onSave(localSelected)}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            Save Selection
          </button>
          <button onClick={onClose} className="text-gray-500 underline">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppSelectorDrawer;
